import React from 'react';
import PropTypes from 'prop-types';
import { environment as env } from 'environments';

import './EnvLabel.scss';

/**
 *  Author **[Taras Khmelovskyi](mailto:taras.khmelovskyi@eleks.com)**
 */

const EnvLabel = ({ styles = {}, isFixed = false }) => {
  const isShowLabel = !!env.topBarLabel && env.topBarLabel !== 'null';
  if (!isShowLabel) return '';
  return (
    <span
      style={styles}
      className={`env-label ${isFixed ? 'env-label__fixed' : ''}`}
    >
      {env.topBarLabel}
    </span>
  );
};

EnvLabel.propTypes = {
  /**
   * EnvLabel position styles
   */
  styles: PropTypes.object,
  isFixed: PropTypes.bool,
};

export default EnvLabel;
